var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalLayout',{attrs:{"icon":"upload-slim","title":"Upload files"},on:{"close":_vm.close}},[_c('UploadFiles',{staticClass:"mt-1",attrs:{"validate":false,"options":{
    url: '/api/social-products/social-boost/screenshots/' + _vm.meta.asset.id,
    accept: ['image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/avi', 'video/mov']
  }},on:{"done":_vm.uploadDone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }